import config from "../config"
const root = config.REACT_APP_API_URL;

export const brandRegister = async (brand) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/brands/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(brand),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response._id) {
          resolve(true);
        }
        reject(response);
      })
      .catch((err) => {
        reject(err)
      });
  });
};

export const brandLogin = async (email, password) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/brands/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.token) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err)
      });
  });
};

// =====================



export const userLogin = async (email, password) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/users/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.token) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err)
      });
  });
};

export const userRegister = async (user) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        console.log(response.status);
        console.log(response.ok);
        if (response._id) {
          resolve(true);
        }
        reject(response);
      })
      .catch((err) => {
        console.log({ err });
        reject(err)
      });
  });
}
